import {SizeSelection_Size} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/size_selection.types';
import {SelectedSize} from '../../../../../features/SizeSelection/hooks/useSelectedSizeState';

export const setFitAnalyticsUsedValue = (
  trackFitAnalytics: (
    action: 'start' | 'complete' | 'close' | 'update',
    value?: string,
  ) => void,
  options: {
    selectedSize: SizeSelection_Size | SelectedSize;
    recommendedSize?: SizeSelection_Size;
  },
) => {
  const {selectedSize: preselectedSize, recommendedSize} = options;

  const recommendedSizeAvailable = Boolean(recommendedSize);

  const recommendedSizeStatus = recommendedSizeAvailable
    ? 'user_data_available'
    : 'user_data_unavailable';

  const preselectedBasedOnRecommendation =
    recommendedSizeAvailable &&
    preselectedSize?.sizeId === recommendedSize?.sizeId &&
    preselectedSize?.availability?.$case === 'inStock';

  const preselectedStatus = preselectedBasedOnRecommendation
    ? 'size_preselected'
    : 'size_not_preselected';

  const fitAnalyticsUsed = `${recommendedSizeStatus}|${preselectedStatus}`;
  trackFitAnalytics('update', fitAnalyticsUsed);
};
